"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5477],{

/***/ 19951:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var SERVICE_TYPE = 'service';
var isServiceType = function isServiceType(item) {
  return item.type === SERVICE_TYPE;
};
/* harmony default export */ __webpack_exports__["Z"] = (isServiceType);

/***/ }),

/***/ 68909:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isValidStaticProp = function isValidStaticProp(str) {
  return !!(str && !str.includes('{{'));
};
/* harmony default export */ __webpack_exports__["Z"] = (isValidStaticProp);

/***/ }),

/***/ 17370:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var cnpjMask = function cnpjMask(value) {
  try {
    return value.replace(/\D+/g, '').slice(0, 14).replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
  } catch (_unused) {
    return '';
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (cnpjMask);

/***/ }),

/***/ 62278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ commons_parseHeaderLinksSuggestions; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(46152);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ../modules/build/esm/commons/randomLinksHeader.js


function fitLinksToCharacterLimit(list, maxCharacters) {
  return list.reduce(function (acc, link) {
    var links = acc.links,
      totalCharacters = acc.totalCharacters;
    if (totalCharacters + link.value.length <= maxCharacters - 1) {
      return {
        links: [].concat((0,toConsumableArray/* default */.Z)(links), [link]),
        totalCharacters: totalCharacters + link.value.length + 1
      };
    }
    return acc;
  }, {
    links: [],
    totalCharacters: 0
  }).links;
}
var randomLinksHeader = function randomLinksHeader(linksHeader, listSize, maxChars) {
  var links = linksHeader.links,
    title = linksHeader.title;
  var randomLinks = shuffle_default()(links);
  var slicedList = randomLinks.slice(0, listSize);
  return fitLinksToCharacterLimit(slicedList, maxChars - title.length);
};
/* harmony default export */ var commons_randomLinksHeader = (randomLinksHeader);
;// CONCATENATED MODULE: ../modules/build/esm/commons/parseHeaderLinksSuggestions.js


var parseHeaderLinksSuggestions = function parseHeaderLinksSuggestions() {
  var _linksSuggestionsData;
  var linksSuggestionsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if ((linksSuggestionsData == null ? void 0 : (_linksSuggestionsData = linksSuggestionsData.links) == null ? void 0 : _linksSuggestionsData.length) > 1 && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.title) && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.listSize) && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.maxChars)) {
    return {
      linksSuggestions: (0,esm_extends/* default */.Z)({}, linksSuggestionsData, {
        links: commons_randomLinksHeader(linksSuggestionsData, linksSuggestionsData.listSize, linksSuggestionsData.maxChars)
      })
    };
  }
  return {};
};
/* harmony default export */ var commons_parseHeaderLinksSuggestions = (parseHeaderLinksSuggestions);

/***/ }),

/***/ 73435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bo": function() { return /* reexport */ shipping_buildShippingData; },
  "_G": function() { return /* reexport */ constants; },
  "b0": function() { return /* reexport */ shipping_parseShippingVariables; }
});

;// CONCATENATED MODULE: ../modules/build/esm/commons/shipping/buildShippingData.js
var buildShippingData = function buildShippingData(_ref) {
  var _deliveries$;
  var deliveries = _ref.deliveries,
    error = _ref.error,
    exceptionDeliveriesId = _ref.exceptionDeliveriesId,
    isClickedCalculateShipping = _ref.isClickedCalculateShipping,
    publish = _ref.publish,
    message = _ref.message,
    setErrorMessage = _ref.setErrorMessage,
    setDeliveryTypes = _ref.setDeliveryTypes,
    shippings = _ref.shippings,
    status = _ref.status,
    zipcode = _ref.zipcode;
  if (error) {
    setErrorMessage(error);
    publish('product:shipping:error', {
      error: error
    });
    return null;
  }
  var deliveriesOptions = deliveries == null ? void 0 : (_deliveries$ = deliveries[0]) == null ? void 0 : _deliveries$.modalities.map(function () {
    var _shippingTime$disclai, _shippingTime$disclai2, _shippingTime$value;
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      shippingTime = _ref2.shippingTime,
      id = _ref2.id,
      cost = _ref2.cost,
      type = _ref2.type;
    return {
      complement: shippingTime == null ? void 0 : (_shippingTime$disclai = shippingTime.disclaimers) == null ? void 0 : (_shippingTime$disclai2 = _shippingTime$disclai[0]) == null ? void 0 : _shippingTime$disclai2.message,
      description: shippingTime == null ? void 0 : shippingTime.description,
      id: id,
      price: cost == null ? void 0 : cost.customer,
      time: shippingTime == null ? void 0 : (_shippingTime$value = shippingTime.value) == null ? void 0 : _shippingTime$value.max,
      type: type,
      unit: shippingTime == null ? void 0 : shippingTime.unit
    };
  });
  setDeliveryTypes(deliveriesOptions);
  if (!isClickedCalculateShipping) {
    publish('product:shipping', {
      deliveries: deliveries,
      error: error,
      exceptionDeliveriesId: exceptionDeliveriesId,
      message: message,
      status: status,
      zipCode: zipcode
    });
  }
  publish('product:shipping:haschanged', {
    deliveries: deliveries,
    shipping: shippings,
    zipcode: zipcode
  });
  return deliveriesOptions;
};
/* harmony default export */ var shipping_buildShippingData = (buildShippingData);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
;// CONCATENATED MODULE: ../modules/build/esm/commons/shipping/parseShippingVariables.js


var _excluded = ["__typename"],
  _excluded2 = ["__typename"];
var parseBundles = function parseBundles(bundles) {
  return bundles.map(function (_ref) {
    var id = _ref.id,
      quantity = _ref.quantity,
      price = _ref.price,
      _ref$dimensions = _ref.dimensions,
      __typename = _ref$dimensions.__typename,
      dimensions = (0,objectWithoutProperties/* default */.Z)(_ref$dimensions, _excluded);
    return {
      dimensions: (0,esm_extends/* default */.Z)({}, dimensions),
      id: id,
      price: price,
      quantity: quantity
    };
  });
};
var parseShippingVariables = function parseShippingVariables() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$pageName = _ref2.pageName,
    pageName = _ref2$pageName === void 0 ? '' : _ref2$pageName,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? {} : _ref2$product,
    _ref2$structure = _ref2.structure,
    structure = _ref2$structure === void 0 ? {} : _ref2$structure,
    _ref2$customZipCode = _ref2.customZipCode,
    customZipCode = _ref2$customZipCode === void 0 ? '' : _ref2$customZipCode;
  var _product$price = product.price,
    _product$price2 = _product$price === void 0 ? {} : _product$price,
    fullPrice = _product$price2.fullPrice,
    listPrice = _product$price2.price,
    currency = _product$price2.currency,
    exchangeRate = _product$price2.exchangeRate,
    idExchangeRate = _product$price2.idExchangeRate,
    originalPriceForeign = _product$price2.originalPriceForeign,
    _product$seller = product.seller,
    _product$seller2 = _product$seller === void 0 ? {} : _product$seller,
    _product$seller2$id = _product$seller2.id,
    sellerId = _product$seller2$id === void 0 ? '' : _product$seller2$id,
    _product$seller2$cate = _product$seller2.category,
    sellerCategory = _product$seller2$cate === void 0 ? '1p' : _product$seller2$cate,
    _product$seller2$sku = _product$seller2.sku,
    sellerSku = _product$seller2$sku === void 0 ? '' : _product$seller2$sku,
    _product$variationId = product.variationId,
    variationId = _product$variationId === void 0 ? '' : _product$variationId,
    _product$type = product.type,
    type = _product$type === void 0 ? '' : _product$type,
    _product$bundles = product.bundles,
    bundles = _product$bundles === void 0 ? [] : _product$bundles,
    _product$dimensions = product.dimensions,
    _product$dimensions2 = _product$dimensions === void 0 ? {} : _product$dimensions,
    __typename = _product$dimensions2.__typename,
    dimensions = (0,objectWithoutProperties/* default */.Z)(_product$dimensions2, _excluded2);
  var price = fullPrice || listPrice;
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    _structure$cookies2$l = _structure$cookies2.location,
    _structure$cookies2$l2 = _structure$cookies2$l === void 0 ? {} : _structure$cookies2$l,
    _structure$cookies2$l3 = _structure$cookies2$l2.zipCode,
    zipcode = _structure$cookies2$l3 === void 0 ? '' : _structure$cookies2$l3,
    _structure$cookies2$a = _structure$cookies2.accountData,
    _structure$cookies2$a2 = _structure$cookies2$a === void 0 ? {} : _structure$cookies2$a,
    _structure$cookies2$a3 = _structure$cookies2$a2.id,
    clientId = _structure$cookies2$a3 === void 0 ? '' : _structure$cookies2$a3,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    _structure$route = structure.route,
    _structure$route2 = _structure$route === void 0 ? {} : _structure$route,
    _structure$route2$cat = _structure$route2.categoryId,
    categoryId = _structure$route2$cat === void 0 ? '' : _structure$route2$cat,
    _structure$route2$sub = _structure$route2.subCategoryId,
    subcategoryId = _structure$route2$sub === void 0 ? '' : _structure$route2$sub,
    _structure$route2$par = _structure$route2.partner_id,
    partnerId = _structure$route2$par === void 0 ? '0' : _structure$route2$par;
  var parsePartnerId = function parsePartnerId(partnerIdParam) {
    if (Array.isArray(partnerIdParam)) return partnerIdParam[0];
    return partnerIdParam;
  };
  return {
    metadata: {
      categoryId: categoryId,
      clientId: clientId,
      organizationId: 'magazine_luiza',
      pageName: pageName,
      partnerId: parsePartnerId(partnerId),
      salesChannelId: config.salesChannelId,
      sellerId: sellerId,
      subcategoryId: subcategoryId
    },
    product: (0,esm_extends/* default */.Z)({
      currency: currency,
      dimensions: (0,esm_extends/* default */.Z)({}, dimensions),
      exchangeRate: parseFloat(exchangeRate),
      id: sellerCategory === '1p' ? variationId : sellerSku,
      idExchangeRate: String(idExchangeRate),
      originalPriceForeign: parseFloat(originalPriceForeign),
      price: parseFloat(price),
      quantity: 1,
      type: type
    }, type === 'bundle' && (bundles == null ? void 0 : bundles.length) > 0 && {
      bundles: parseBundles(bundles)
    }),
    zipcode: customZipCode || zipcode
  };
};
/* harmony default export */ var shipping_parseShippingVariables = (parseShippingVariables);
;// CONCATENATED MODULE: ../modules/build/esm/commons/shipping/constants.js
/* harmony default export */ var constants = ({
  button: {
    actionLabel: 'calcular',
    changeLabel: 'alterar',
    maxCityLength: 24,
    placeholder: 'Calcular frete e prazo'
  },
  error: {
    NOT_AVAILABLE: 'not_available'
  },
  labels: {
    conventional: {
      complement: 'após o pagamento confirmado',
      "default": 'Entrega em até 1h',
      plural: 'Receber em até {X} dias úteis',
      singular: 'Receber em até 1 dia útil'
    },
    store_pickup: {
      complement: 'após o pagamento confirmado',
      "default": 'Retirar na loja em 2h',
      plural: 'Retirar na loja em até {X} dias úteis',
      singular: 'Retirar na loja em até 1 dia útil'
    }
  }
});
;// CONCATENATED MODULE: ../modules/build/esm/commons/shipping/index.js




/***/ }),

/***/ 10105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogLinkList_BlogLinkList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 121 modules
var esm = __webpack_require__(82311);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogLinkList/BlogLinkList.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;





var Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    p: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    borderRadius: 'default',
    textAlign: 'left'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 1366px;\n  margin: 0 auto;\n"])));
var Item = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    fontWeight: 'medium',
    forwardedAs: 'li',
    lineHeight: 'big',
    my: 2,
    px: 2,
    py: 1
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: ", ";\n  display: inline-block;\n  margin-right: ", "px;\n  font-size: ", "px;\n  border: 1px solid ", ";\n  & a {\n    display: inline-block;\n    line-height: normal;\n  }\n"])), function (props) {
  return (0,build_esm.themeGet)('radii.default')(props);
}, (0,build_esm.themeGet)('space.3'), (0,build_esm.themeGet)('fontSizes.2'), (0,build_esm.getBackgroundColor)('primary'));
var BlogLinkList_styles_Link = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function () {
  return {
    color: 'text.primary',
    fontSize: 2,
    underlineOnHover: false
  };
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var List = styled_components_browser_esm["default"].ul(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style-position: inside;\n  justify-content: space-around;\n  display: inline;\n  font-size: inherit;\n  line-height: normal;\n"])));
var Title = (0,styled_components_browser_esm["default"])(Heading/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  padding-bottom: ", "px;\n  line-height: normal;\n  font-size: ", "px;\n\n  ", " {\n    font-size: ", "px;\n  }\n"])), function (props) {
  return (0,build_esm.getTextColor)('base')(props);
}, (0,build_esm.themeGet)('space.3'), (0,build_esm.themeGet)('fontSizes.4'), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('fontSizes.5'));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogLinkList/BlogLinkList.js


var _excluded = ["titleAs", "items", "title"];





var BlogLinkList = function BlogLinkList(_ref) {
  var id = _ref.id,
    staticProps = _ref["static"];
  var handleClickLink = function handleClickLink(e, href) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  var _staticProps$titleAs = staticProps.titleAs,
    titleAs = _staticProps$titleAs === void 0 ? 'h2' : _staticProps$titleAs,
    _staticProps$items = staticProps.items,
    items = _staticProps$items === void 0 ? [] : _staticProps$items,
    title = staticProps.title,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  return Boolean(items == null ? void 0 : items.length) && react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "link-list-container"
  }, props), react.createElement(Content, null, title && react.createElement(Title, {
    forwardedAs: titleAs,
    "data-testid": "link-list-title"
  }, title), react.createElement(List, {
    "data-testid": "link-list-ul"
  }, items == null ? void 0 : items.map(function (item, index) {
    return react.createElement(Item, {
      key: "".concat(id, "-").concat(index + 1),
      "data-testid": "link-list-text"
    }, react.createElement(BlogLinkList_styles_Link, {
      alt: item.alt,
      href: item == null ? void 0 : item.href,
      onClick: function onClick(e) {
        return handleClickLink(e, item.href);
      }
    }, item.value));
  }))));
};
 false ? 0 : void 0;
BlogLinkList.defaultProps = {
  id: 'list',
  "static": {},
  structure: {}
};
BlogLinkList.ssr = true;
/* harmony default export */ var BlogLinkList_BlogLinkList = ((0,withLayoutProps/* default */.Z)(BlogLinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogLinkList/index.js


/***/ }),

/***/ 58035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BlogBreadCrumb": function() { return /* reexport */ BlogBreadCrumb_BlogBreadCrumb; },
  "BlogEcommerceLink": function() { return /* reexport */ BlogEcommerceLink_BlogEcommerceLink; },
  "BlogFooter": function() { return /* reexport */ BlogFooter_BlogFooter; },
  "BlogHeader": function() { return /* reexport */ BlogHeader_BlogHeader; },
  "BlogHeaderDesk": function() { return /* reexport */ BlogHeaderDesk_BlogHeaderDesk; },
  "BlogLinkList": function() { return /* reexport */ BlogLinkList/* default */.Z; },
  "BlogPagination": function() { return /* reexport */ BlogPagination_BlogPagination; },
  "BlogPostMetaData": function() { return /* reexport */ BlogPostMetaData_BlogPostMetaData; },
  "BlogPostsList": function() { return /* reexport */ BlogPostsList_BlogPostsList; },
  "BlogRecommendation": function() { return /* reexport */ BlogRecommendation_BlogRecommendation; },
  "BlogShareActions": function() { return /* reexport */ BlogShareActions_BlogShareActions; },
  "BlogSubLinksRelated": function() { return /* reexport */ BlogSubLinksRelated_BlogSubLinksRelated; },
  "BlogTagList": function() { return /* reexport */ BlogTagList_BlogTagList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js + 2 modules
var Strip = __webpack_require__(85737);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogShareActions/BlogShareActions.utils.js
var parseShareLinks = function parseShareLinks() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _data$url = data.url,
    url = _data$url === void 0 ? '' : _data$url,
    _data$title = data.title,
    title = _data$title === void 0 ? '' : _data$title,
    _data$domain = data.domain,
    domain = _data$domain === void 0 ? '' : _data$domain;
  var txtUrl = "".concat(domain, "/").concat(url);
  var txtTitle = encodeURIComponent(title);
  return {
    urlFacebook: "https://www.facebook.com/sharer/sharer.php?u=".concat(txtUrl),
    urlLinkedIn: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(txtUrl),
    urlTwitter: "https://twitter.com/intent/tweet?text=".concat(txtTitle, "&url=").concat(txtUrl),
    urlWhatsApp: "https://wa.me/?text=".concat(txtUrl)
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogShareActions/BlogShareActions.js


var _excluded = ["links", "title", "theme", "slug"];








var BlogShareActions = function BlogShareActions(_ref) {
  var _structure$config;
  var data = _ref.data,
    structure = _ref.structure,
    _ref$static = _ref["static"],
    _ref$static$links = _ref$static.links,
    links = _ref$static$links === void 0 ? [] : _ref$static$links,
    title = _ref$static.title,
    _ref$static$theme = _ref$static.theme,
    _ref$static$theme2 = _ref$static$theme === void 0 ? {} : _ref$static$theme,
    _ref$static$theme2$ic = _ref$static$theme2.iconColor,
    iconColor = _ref$static$theme2$ic === void 0 ? 'background.dark' : _ref$static$theme2$ic,
    _ref$static$theme2$ba = _ref$static$theme2.backgroundColor,
    backgroundColor = _ref$static$theme2$ba === void 0 ? 'background.light' : _ref$static$theme2$ba,
    slug = _ref$static.slug,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded);
  var _ref2 = (data == null ? void 0 : data.blogPostContent) || {},
    _ref2$title = _ref2.title,
    postTitle = _ref2$title === void 0 ? '' : _ref2$title,
    seo = _ref2.seo;
  var domain = structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.domain;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var parsedLinks = parseShareLinks({
    domain: domain,
    title: (seo == null ? void 0 : seo.title) || postTitle,
    url: slug
  });
  var socialItems = links.map(function (shareItem) {
    return (0,esm_extends/* default */.Z)({}, shareItem, {
      url: (parsedLinks == null ? void 0 : parsedLinks[shareItem.url]) || shareItem.url
    });
  });
  var handleShare = function handleShare(socialName) {
    publish('shareblog:click', {
      socialName: socialName
    });
  };
  var SocialIcons = {
    Facebook: react.createElement(esm/* Facebook */.s1S, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    Instagram: react.createElement(esm/* Instagram */.mre, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    LinkedIn: react.createElement(esm/* LinkedIn */.yhk, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    Tiktok: react.createElement(esm/* Tiktok */.yAo, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    Twitter: react.createElement(esm/* Twitter */.tLe, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    WhatsApp: react.createElement(esm/* WhatsApp */.w26, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    }),
    Youtube: react.createElement(esm/* Youtube */.hxd, {
      width: 20,
      height: 20,
      color: iconColor,
      "data-testid": "blog-share-icon"
    })
  };
  return Boolean(links.length) && react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    flexDirection: "column"
  }, props, {
    "data-testid": "blog-share-container"
  }), title && react.createElement(Text/* default */.Z, {
    color: "inherit",
    fontWeight: "medium",
    textAlign: ['center', 'center', 'left'],
    fontSize: 0,
    "data-testid": "blog-share-title"
  }, title), react.createElement(Flex/* default */.Z, {
    columnGap: 3,
    mt: 2
  }, socialItems == null ? void 0 : socialItems.map(function (_ref3) {
    var alt = _ref3.alt,
      icon = _ref3.icon,
      url = _ref3.url;
    return react.createElement(Link/* default */.Z, {
      alt: alt,
      key: "share-actions-".concat(icon),
      href: url,
      target: "_blank"
    }, react.createElement(Flex/* default */.Z, {
      width: 32,
      height: 32,
      borderRadius: "circle",
      bg: backgroundColor,
      justifyContent: "center",
      alignItems: "center",
      p: 1,
      "data-testid": "blog-share-icon-container",
      onClick: function onClick() {
        return handleShare(icon);
      }
    }, SocialIcons[icon]));
  })));
};
BlogShareActions.ssr = true;
 false ? 0 : void 0;
BlogShareActions.defaultProps = {
  data: {
    blogPostContent: {}
  },
  "static": {},
  structure: {}
};
/* harmony default export */ var BlogShareActions_BlogShareActions = (BlogShareActions);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogShareActions/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogFooter/BlogFooter.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;






var Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.primary',
    color: 'text.light'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-content: center;\n  width: 100%;\n\n  border-top-style: solid;\n  border-top-color: ", ";\n  border-top-width: ", "px;\n\n  ", " {\n    border-top-width: 40px;\n  }\n\n  ", "\n"])), function (props) {
  return (0,build_esm.getPaletteColor)('primary.light')(props);
}, (0,build_esm.themeGet)('space.2'), (0,build_esm.getMediaQuery)('medium'), build_esm.color);
var ContentWrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  width: 100%;\n  row-gap: ", "px;\n\n  max-width: 360px;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  ", " {\n    max-width: 1400px;\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n  }\n"])), (0,build_esm.themeGet)('space.5'), (0,build_esm.themeGet)('space.4'), (0,build_esm.themeGet)('space.5'), (0,build_esm.themeGet)('space.3'), (0,build_esm.themeGet)('space.3'), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('space.6'), (0,build_esm.themeGet)('space.4'));
var FooterSeparator = styled_components_browser_esm["default"].hr(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-area: separator;\n  height: 1px;\n  width: 60px;\n\n  ", " {\n    display: none;\n  }\n"])), (0,build_esm.getMediaQuery)('medium'));
var LinkList = (0,styled_components_browser_esm["default"])(Grid/* default */.Z).attrs(function () {
  return {
    fontWeight: 'medium',
    forwardedAs: 'ul',
    gridColumnGap: 5,
    gridRowGap: 3
  };
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  text-align: left;\n  grid-template-rows: ", ";\n\n  ", " {\n    grid-template-rows: repeat(5, 1fr);\n  }\n"])), function (_ref) {
  var _ref$length = _ref.length,
    length = _ref$length === void 0 ? 0 : _ref$length;
  return "repeat(".concat(Math.round(length / 2), ", 1fr)");
}, (0,build_esm.getMediaQuery)('medium'));
var SectionCopyright = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  align-items: center;\n"])));
var SectionEcommerceLink = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-area: ecommercelink;\n  justify-content: center;\n"])));
var SectionLinks = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-content: center;\n"])));
var SectionLogo = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-area: logo;\n  display: none;\n\n  ", " {\n    display: block;\n  }\n"])), (0,build_esm.getMediaQuery)('medium'));
var SectionSocial = (0,styled_components_browser_esm["default"])(BlogShareActions_BlogShareActions)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-area: social;\n  flex-direction: column;\n  align-items: center;\n\n  ", " {\n    align-items: start;\n  }\n"])), (0,build_esm.getMediaQuery)('medium'));
var SectionsWrapper = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-template-areas: 'ecommercelink' 'separator' 'social';\n  row-gap: ", "px;\n  justify-items: center;\n\n  ", " {\n    grid-template-areas: 'logo ecommercelink social';\n    grid-template-columns: repeat(3, 1fr);\n    align-items: end;\n    justify-items: center;\n  }\n"])), (0,build_esm.themeGet)('space.4'), (0,build_esm.getMediaQuery)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogFooter/BlogFooter.js










var BlogFooter = function BlogFooter(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data;
  var socialNetworks = staticProps.socialNetworks,
    ecommerceLink = staticProps.ecommerceLink;
  var _data$blogFooter = data.blogFooter,
    footerData = _data$blogFooter === void 0 ? {} : _data$blogFooter;
  var linkList = (footerData == null ? void 0 : footerData.linkList) || [];
  return react.createElement(Container, {
    "data-testid": "blog-footer-container"
  }, react.createElement(ContentWrapper, null, react.createElement(SectionLinks, null, react.createElement(LinkList, {
    length: linkList.length
  }, linkList == null ? void 0 : linkList.map(function (link) {
    return react.createElement("li", {
      key: link.text
    }, react.createElement(Link/* default */.Z, {
      href: link.href,
      color: "inherit",
      fontSize: 2,
      lineHeight: 1.25
    }, link.text));
  }))), react.createElement(SectionsWrapper, null, react.createElement(SectionLogo, null, react.createElement(esm/* Icon */.JO$, {
    name: "LogoBlogLu",
    color: "text.light",
    width: 200,
    height: 36
  })), ecommerceLink && react.createElement(SectionEcommerceLink, null, react.createElement(Link/* default */.Z, {
    href: ecommerceLink.href
  }, react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: "center",
    bg: "background.light",
    p: 3,
    borderRadius: "big",
    width: 230,
    height: 48
  }, react.createElement(Text/* default */.Z, {
    color: "primary.dark",
    fontWeight: "bold",
    fontSize: 2
  }, ecommerceLink.label)))), react.createElement(FooterSeparator, null), react.createElement(SectionSocial, {
    "static": {
      links: socialNetworks == null ? void 0 : socialNetworks.links,
      theme: {
        iconColor: 'primary.dark'
      },
      title: socialNetworks == null ? void 0 : socialNetworks.title
    }
  })), react.createElement(SectionCopyright, null, react.createElement(esm/* Icon */.JO$, {
    name: "LogoMagalu",
    color: "text.white",
    width: 120,
    height: 20,
    viewBox: "0 0 60 13"
  }), react.createElement(Box/* default */.Z, {
    width: 85
  }, react.createElement(Strip/* default */.Z, {
    size: 3,
    position: "relative"
  })))));
};
 false ? 0 : void 0;
BlogFooter.defaultProps = {
  data: {},
  "static": {}
};
BlogFooter.ssr = true;
BlogFooter.displayName = 'BlogFooter';
/* harmony default export */ var BlogFooter_BlogFooter = ((0,withLayoutProps/* default */.Z)(BlogFooter));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogFooter/index.js

// EXTERNAL MODULE: ../modules/build/esm/components/blog/BlogLinkList/index.js + 2 modules
var BlogLinkList = __webpack_require__(10105);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 121 modules
var utils_build_esm = __webpack_require__(82311);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogTagList/BlogTagList.styles.js


var BlogTagList_styles_templateObject, BlogTagList_styles_templateObject2, BlogTagList_styles_templateObject3, BlogTagList_styles_templateObject4;



var BlogTagList_styles_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    borderRadius: 'default',
    textAlign: 'left'
  }, props);
})(BlogTagList_styles_templateObject || (BlogTagList_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Item = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    backgroundColor: 'background.lightPurple',
    borderRadius: 'default',
    fontSize: '2',
    fontWeight: 'medium',
    forwardedAs: 'li',
    lineHeight: 'big',
    mr: 3,
    my: 2,
    px: 2,
    py: 1
  };
})(BlogTagList_styles_templateObject2 || (BlogTagList_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  display: inline-block;\n\n  & a {\n    display: inline-block;\n    line-height: normal;\n  }\n"])));
var BlogTagList_styles_Link = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function () {
  return {
    color: 'text.primary',
    fontSize: 2,
    fontWeight: 'medium',
    underlineOnHover: false
  };
})(BlogTagList_styles_templateObject3 || (BlogTagList_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var List = styled_components_browser_esm["default"].ul(BlogTagList_styles_templateObject4 || (BlogTagList_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style-position: inside;\n  justify-content: space-between;\n  display: inline;\n  font-size: inherit;\n  line-height: normal;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogTagList/BlogTagList.js


var BlogTagList_excluded = ["tags"];





var BlogTagList = function BlogTagList(_ref) {
  var id = _ref.id,
    _ref$static = _ref["static"],
    _ref$static$tags = _ref$static.tags,
    tags = _ref$static$tags === void 0 ? [] : _ref$static$tags,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, BlogTagList_excluded);
  var mountUrl = function mountUrl(item) {
    return "/blog-da-lu/t/".concat(item.slug, "/").concat(item.id, "/");
  };
  var handleTagClick = function handleTagClick(e, item) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: mountUrl(item),
      spa: true
    });
  };
  return Boolean(tags == null ? void 0 : tags.length) && react.createElement(BlogTagList_styles_Container, (0,esm_extends/* default */.Z)({
    "data-testid": "tag-list-container"
  }, props), react.createElement(List, {
    "data-testid": "tag-list-ul"
  }, tags.map(function (item, index) {
    return react.createElement(Item, {
      key: "".concat(id, "-").concat(index + 1),
      "data-testid": "tag-list-text",
      onClick: function onClick(e) {
        return handleTagClick(e, item);
      }
    }, react.createElement(BlogTagList_styles_Link, {
      alt: item.title,
      href: mountUrl(item),
      onClick: function onClick(e) {
        return handleTagClick(e, item);
      }
    }, item.title));
  })));
};
 false ? 0 : void 0;
BlogTagList.defaultProps = {
  id: 'taglist',
  "static": {}
};
BlogTagList.ssr = true;
/* harmony default export */ var BlogTagList_BlogTagList = ((0,withLayoutProps/* default */.Z)(BlogTagList));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogTagList/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/BlogRecommendation.styles.js

var BlogRecommendation_styles_templateObject, BlogRecommendation_styles_templateObject2, BlogRecommendation_styles_templateObject3, BlogRecommendation_styles_templateObject4;




var BlogRecommendation_styles_Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    disableBackground = _ref.disableBackground;
  return {
    backgroundColor: disableBackground ? 'transparent' : backgroundColor
  };
})(BlogRecommendation_styles_templateObject || (BlogRecommendation_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  clear: both;\n"])));
var Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(BlogRecommendation_styles_templateObject2 || (BlogRecommendation_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 1366px;\n  margin: 0 auto;\n"])));
var Title = (0,styled_components_browser_esm["default"])(Heading/* default */.Z)(BlogRecommendation_styles_templateObject3 || (BlogRecommendation_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var TitleContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(BlogRecommendation_styles_templateObject4 || (BlogRecommendation_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  ", " {\n    justify-content: flex-start;\n  }\n  gap: 24px;\n"])), (0,build_esm.getMediaQuery)('small'));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/variations.utils.js
var createCustomUrl = function createCustomUrl(category, subcategory) {
  if (!category || !subcategory) {
    return null;
  }
  return "/blog-da-lu/s/".concat(category.categoryId, "/").concat(subcategory.categoryId, "/").concat(subcategory.slug, "/").concat(subcategory.id).toLocaleLowerCase();
};
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/BannerCarousel/BannerCarousel.js









function BannerCarousel(_ref) {
  var posts = _ref.posts,
    cardTheme = _ref.cardTheme,
    viewport = _ref.viewport,
    titleAs = _ref.titleAs,
    customBasePath = _ref.customBasePath;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handlePostClick = function handlePostClick(categoryId, e, title, slug, postId) {
    e.preventDefault();
    var recomendationLayout = 'BannerCarousel';
    (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(postId, "/"),
      spa: true
    });
    publish('blogpost:click', {
      categoryId: categoryId,
      recomendationLayout: recomendationLayout,
      title: title
    });
  };
  var handleSubCategoryPostClick = function handleSubCategoryPostClick(category, subcategory, e) {
    var subcategoryUrl = createCustomUrl(category, subcategory);
    e.stopPropagation();
    (0,utils_build_esm/* routePush */.dY)({
      path: subcategoryUrl,
      spa: true
    });
  };
  return react.createElement(Carousel/* default */.Z, {
    "data-testid": "banner-carousel-variation",
    auto: false,
    duration: 400,
    gutter: 15,
    interval: 3000,
    insideControls: true,
    showPartialNextSlide: viewport === 'mobile',
    showArrowControls: viewport === 'desktop'
  }, posts == null ? void 0 : posts.map(function (_ref2) {
    var _image$urls, _parseDateTime;
    var id = _ref2.id,
      image = _ref2.image,
      title = _ref2.title,
      categoryTitle = _ref2.categoryTitle,
      categoryId = _ref2.categoryId,
      updatedAt = _ref2.updatedAt,
      subtitle = _ref2.subtitle,
      slug = _ref2.slug,
      category = _ref2.category,
      subcategory = _ref2.subcategory;
    return react.createElement(Card/* default */.ZP, {
      key: id,
      as: "a",
      href: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(id, "/"),
      backgroundColor: cardTheme,
      enableHover: true,
      "data-testid": "banner-carousel-card",
      gridTemplateAreas: ["'image' 'body'", "'image' 'body'", "'image body'"],
      gridTemplateColumns: ['1fr', '1fr', '3fr 1fr'],
      gridTemplateRows: ['300px 1fr', '400px 1fr', '500px 1fr'],
      height: ['500px', '600px', 'auto'],
      onClick: function onClick(e) {
        return handlePostClick(categoryId, e, title, slug, id);
      }
    }, react.createElement(Card/* default.Image */.ZP.Image, {
      src: "".concat(image == null ? void 0 : (_image$urls = image.urls) == null ? void 0 : _image$urls["default"], "?ims=fit-in/{w}x"),
      alt: image.alt,
      srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
      width: viewport === 'mobile' ? 346 : 960,
      objectFit: "cover"
    }), react.createElement(Card/* default.Body */.ZP.Body, null, react.createElement(Card/* default.Title */.ZP.Title, {
      forwardedAs: titleAs,
      truncate: true,
      lines: viewport === 'desktop' ? 4 : 2,
      fontSize: [5, 6, 8]
    }, title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
      fontSize: [2, 2, 2]
    }, Boolean(updatedAt) && "".concat((_parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt)) == null ? void 0 : _parseDateTime.getShortMonthYear, " | "), react.createElement(Text/* default */.Z, {
      fontWeight: "bold",
      color: "inherit",
      display: "inline-block"
    }, categoryTitle)), react.createElement(Card/* default.Text */.ZP.Text, {
      truncate: true,
      lines: 4,
      fontSize: [2, 2, 3]
    }, subtitle), subcategory && react.createElement(Link/* default */.Z, {
      p: "8px 0",
      color: "inherit",
      fontWeight: "bold",
      "data-testid": "blog-subCategory-link",
      href: createCustomUrl(category, subcategory),
      onClick: function onClick(e) {
        return handleSubCategoryPostClick(category, subcategory, e);
      }
    }, subcategory.title)));
  }));
}
 false ? 0 : void 0;
BannerCarousel.defaultProps = {
  cardTheme: 'background.light',
  customBasePath: '',
  titleAs: 'h3',
  viewport: 'mobile'
};
/* harmony default export */ var BannerCarousel_BannerCarousel = (BannerCarousel);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/BannerCarousel/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/Carousel/Carousel.js









function Carousel_Carousel(_ref) {
  var cardTheme = _ref.cardTheme,
    posts = _ref.posts,
    viewport = _ref.viewport,
    titleAs = _ref.titleAs,
    customBasePath = _ref.customBasePath;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handlePostClick = function handlePostClick(categoryId, e, title, slug, postId) {
    e.preventDefault();
    var recomendationLayout = 'Carousel';
    (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(postId, "/"),
      spa: true
    });
    publish('blogpost:click', {
      categoryId: categoryId,
      recomendationLayout: recomendationLayout,
      title: title
    });
  };
  var handleSubCategoryPostClick = function handleSubCategoryPostClick(category, subcategory, e) {
    var subcategoryUrl = createCustomUrl(category, subcategory);
    e.stopPropagation();
    (0,utils_build_esm/* routePush */.dY)({
      path: subcategoryUrl,
      spa: true
    });
  };
  return react.createElement(Carousel/* default */.Z, {
    "data-testid": "carousel-variation",
    auto: false,
    showControls: false,
    duration: 400,
    gutter: 15,
    interval: 3000,
    insideControls: true,
    showArrowControls: true,
    slidesPerView: viewport === 'desktop' ? 2 : 1
  }, posts == null ? void 0 : posts.map(function (_ref2) {
    var _image$urls, _parseDateTime;
    var id = _ref2.id,
      image = _ref2.image,
      title = _ref2.title,
      categoryId = _ref2.categoryId,
      categoryTitle = _ref2.categoryTitle,
      updatedAt = _ref2.updatedAt,
      subtitle = _ref2.subtitle,
      slug = _ref2.slug,
      category = _ref2.category,
      subcategory = _ref2.subcategory;
    return react.createElement(Card/* default */.ZP, {
      key: id,
      as: "a",
      href: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(id, "/"),
      backgroundColor: cardTheme,
      enableHover: true,
      "data-testid": "carousel-card",
      gridTemplateRows: ['250px 1f r', '400px 1fr', '450px 1fr'],
      height: ['480px', '650px', '700px'],
      gridTemplateColumns: "1fr",
      onClick: function onClick(e) {
        return handlePostClick(categoryId, e, title, slug, id);
      }
    }, react.createElement(Card/* default.Image */.ZP.Image, {
      src: "".concat(image == null ? void 0 : (_image$urls = image.urls) == null ? void 0 : _image$urls["default"], "?ims=fit-in/{w}x"),
      alt: image.alt,
      srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
      width: viewport === 'mobile' ? 380 : 660,
      imageHeight: ['250px', '400px', '450px']
    }), react.createElement(Card/* default.Body */.ZP.Body, null, react.createElement(Card/* default.Title */.ZP.Title, {
      forwardedAs: titleAs,
      truncate: true,
      lines: 2,
      fontSize: [4, 5, 5],
      lineHeight: ['display', 'input', 'input']
    }, title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
      fontSize: [2, 2, 2]
    }, Boolean(updatedAt) && "".concat((_parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt)) == null ? void 0 : _parseDateTime.getShortMonthYear, " | "), react.createElement(Text/* default */.Z, {
      fontWeight: "bold",
      color: "inherit",
      display: "inline-block"
    }, categoryTitle)), react.createElement(Card/* default.Text */.ZP.Text, {
      truncate: true,
      lines: 4,
      fontSize: [2, 3, 3]
    }, subtitle), subcategory && react.createElement(Link/* default */.Z, {
      p: "8px 0",
      color: "inherit",
      fontWeight: "bold",
      "data-testid": "blog-subCategory-link",
      href: createCustomUrl(category, subcategory),
      onClick: function onClick(e) {
        return handleSubCategoryPostClick(category, subcategory, e);
      }
    }, subcategory.title)));
  }));
}
 false ? 0 : void 0;
Carousel_Carousel.defaultProps = {
  cardTheme: 'background.light',
  customBasePath: '',
  titleAs: 'h3',
  viewport: 'mobile'
};
/* harmony default export */ var Variations_Carousel_Carousel = (Carousel_Carousel);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/Carousel/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(46840);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/Highlight/Highlight.styles.js

var Highlight_styles_templateObject;



var Highlight_styles_Container = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(Highlight_styles_templateObject || (Highlight_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-template-areas: 'highlighted' 'listing';\n  row-gap: ", "px;\n\n  ", " {\n    grid-template-areas: 'highlighted listing';\n    column-gap: ", "px;\n    grid-template-columns: 57% auto;\n  }\n"])), (0,build_esm.themeGet)('space.3'), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('space.4'));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/Highlight/Highlight.js











function Highlight(_ref) {
  var _highlightedPost$imag, _highlightedPost$imag2, _parseDateTime;
  var posts = _ref.posts,
    cardTheme = _ref.cardTheme,
    titleAs = _ref.titleAs,
    viewport = _ref.viewport,
    customBasePath = _ref.customBasePath;
  var _posts = (0,toArray/* default */.Z)(posts),
    highlightedPost = _posts[0],
    otherPosts = _posts.slice(1);
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handlePostClick = function handlePostClick(categoryId, title, e, slug, postId) {
    e.preventDefault();
    var recomendationLayout = 'Highlight';
    (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(postId, "/"),
      spa: true
    });
    publish('blogpost:click', {
      categoryId: categoryId,
      recomendationLayout: recomendationLayout,
      title: title
    });
  };
  var handleSubCategoryPostClick = function handleSubCategoryPostClick(category, subcategory, e) {
    var updatedCategory = highlightedPost.category;
    var updatedSubcategory = highlightedPost.subcategory;
    e.stopPropagation();
    var subcategoryUrl = createCustomUrl(updatedCategory, updatedSubcategory);
    (0,utils_build_esm/* routePush */.dY)({
      path: subcategoryUrl,
      spa: true
    });
  };
  return react.createElement(Highlight_styles_Container, {
    "data-testid": "highlight-variation"
  }, react.createElement(Grid/* default */.Z, {
    width: "100%",
    gridArea: "highlighted"
  }, react.createElement(Card/* default */.ZP, {
    key: highlightedPost.id,
    as: "a",
    href: "".concat(customBasePath, "/blog-da-lu/c/").concat(highlightedPost.slug, "/").concat(highlightedPost.id, "/"),
    backgroundColor: cardTheme,
    enableHover: true,
    gridTemplateRows: [null, null, 'auto 1fr'],
    gridTemplateColumns: "1fr",
    "data-testid": "main-highlight-card",
    onClick: function onClick(e) {
      return handlePostClick(highlightedPost.categoryId, highlightedPost.title, e, highlightedPost.slug, highlightedPost.id);
    }
  }, react.createElement(Card/* default.Image */.ZP.Image, {
    src: "".concat((_highlightedPost$imag = highlightedPost.image) == null ? void 0 : (_highlightedPost$imag2 = _highlightedPost$imag.urls) == null ? void 0 : _highlightedPost$imag2["default"], "?ims=fit-in/{w}x"),
    srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
    width: viewport === 'mobile' ? 380 : 630,
    objectFit: "cover",
    imageHeight: ['320px', '100%', '420px']
  }), react.createElement(Card/* default.Body */.ZP.Body, null, react.createElement(Card/* default.Title */.ZP.Title, {
    forwardedAs: titleAs,
    truncate: true,
    lines: 2,
    fontSize: [5]
  }, highlightedPost.title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
    fontSize: [null, 1, 1]
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    color: "inherit",
    display: "inline-block"
  }, highlightedPost.categoryTitle), Boolean(highlightedPost.updatedAt) && " | ".concat((_parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(highlightedPost.updatedAt)) == null ? void 0 : _parseDateTime.getShortMonthYear)), react.createElement(Card/* default.Text */.ZP.Text, {
    truncate: true,
    lines: 4
  }, highlightedPost.subtitle), (highlightedPost == null ? void 0 : highlightedPost.subcategory) && react.createElement(Link/* default */.Z, {
    p: "8px 0",
    color: "inherit",
    fontWeight: "bold",
    "data-testid": "blog-subCategory-link",
    href: createCustomUrl(highlightedPost.category, highlightedPost.subcategory),
    onClick: function onClick(e) {
      return handleSubCategoryPostClick(highlightedPost.category, highlightedPost.subcategory, e);
    }
  }, highlightedPost.subcategory.title)))), react.createElement(Grid/* default */.Z, {
    gridArea: "listing",
    rowGap: 20,
    gridTemplateRows: "repeat(3, min-content)"
  }, otherPosts == null ? void 0 : otherPosts.map(function (_ref2) {
    var _image$urls, _parseDateTime2;
    var id = _ref2.id,
      image = _ref2.image,
      title = _ref2.title,
      categoryId = _ref2.categoryId,
      categoryTitle = _ref2.categoryTitle,
      updatedAt = _ref2.updatedAt,
      slug = _ref2.slug,
      category = _ref2.category,
      subcategory = _ref2.subcategory;
    return react.createElement(Card/* default */.ZP, {
      key: id,
      as: "a",
      href: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(id, "/"),
      backgroundColor: "background.base",
      enableHover: true,
      "data-testid": "highlight-card",
      gridTemplateAreas: "'image body'",
      gridTemplateColumns: ['180px 1fr', '250px 1fr', '250px 1fr'],
      borderRadius: "12px",
      onClick: function onClick(e) {
        return handlePostClick(categoryId, title, e, slug, id);
      }
    }, react.createElement(Card/* default.Image */.ZP.Image, {
      imageWidth: [null, '250px'],
      imageHeight: ['127px', '192px'],
      objectFit: "cover",
      borderRadius: 6,
      src: "".concat(image == null ? void 0 : (_image$urls = image.urls) == null ? void 0 : _image$urls["default"], "?ims=fit-in/{w}x"),
      alt: image.alt,
      srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
      width: viewport === 'mobile' ? 180 : 250
    }), react.createElement(Card/* default.Body */.ZP.Body, null, react.createElement(Card/* default.Title */.ZP.Title, {
      forwardedAs: titleAs,
      truncate: true,
      lines: 2,
      fontSize: 3
    }, title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
      truncate: true,
      lines: 1,
      fontSize: 1
    }, react.createElement(Text/* default */.Z, {
      fontWeight: "bold",
      color: "inherit",
      display: "inline-block"
    }, categoryTitle), Boolean(updatedAt) && " | ".concat((_parseDateTime2 = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt)) == null ? void 0 : _parseDateTime2.getShortMonthYear)), subcategory && react.createElement(Link/* default */.Z, {
      p: "8px 0",
      color: "inherit",
      fontWeight: "bold",
      "data-testid": "blog-subCategory-link",
      href: createCustomUrl(category, subcategory),
      onClick: function onClick(e) {
        return handleSubCategoryPostClick(category, subcategory, e);
      }
    }, subcategory.title)));
  })));
}
 false ? 0 : void 0;
Highlight.defaultProps = {
  cardTheme: 'primary.dark',
  customBasePath: '',
  titleAs: 'h3',
  viewport: 'mobile'
};
/* harmony default export */ var Highlight_Highlight = (Highlight);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/Highlight/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/List/List.styles.js


var List_styles_templateObject, List_styles_templateObject2;




var CardText = (0,styled_components_browser_esm["default"])(Card/* default.Text */.ZP.Text)(List_styles_templateObject || (List_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 100px;\n"])));
var List_styles_Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(List_styles_templateObject2 || (List_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: ", "px;\n\n  ", " {\n    flex-direction: row;\n    gap: ", "px 4%;\n\n    > * {\n      flex-basis: 48%;\n    }\n  }\n\n  ", " {\n    flex-direction: row;\n    gap: ", "px 2%;\n\n    & > :last-child {\n      display: none;\n    }\n\n    > * {\n      flex-basis: 31.333%;\n    }\n  }\n\n  ", " {\n    flex-direction: row;\n    gap: ", "px 1%;\n\n    & > :last-child {\n      display: grid;\n    }\n\n    > * {\n      flex-basis: ", "%;\n    }\n  }\n"])), (0,build_esm.themeGet)('space.4'), (0,build_esm.getMediaQuery)('small'), (0,build_esm.themeGet)('space.4'), (0,build_esm.getMediaQuery)('medium'), (0,build_esm.themeGet)('space.4'), (0,build_esm.getMediaQuery)('large'), (0,build_esm.themeGet)('space.4'), function (props) {
  return props.columns ? 96 / props.columns : 24;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/List/List.js









function List_List(_ref) {
  var columns = _ref.columns,
    posts = _ref.posts,
    cardTheme = _ref.cardTheme,
    displaySubtitle = _ref.displaySubtitle,
    titleAs = _ref.titleAs,
    viewport = _ref.viewport,
    customBasePath = _ref.customBasePath;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handlePostClick = function handlePostClick(categoryId, title, e, slug, postId) {
    e.preventDefault();
    var recomendationLayout = 'List';
    (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(postId, "/"),
      spa: true
    });
    publish('blogpost:click', {
      categoryId: categoryId,
      recomendationLayout: recomendationLayout,
      title: title
    });
  };
  var handleSubCategoryPostClick = function handleSubCategoryPostClick(category, subcategory, e) {
    e.stopPropagation();
    var subcategoryUrl = createCustomUrl(category, subcategory);
    (0,utils_build_esm/* routePush */.dY)({
      path: subcategoryUrl,
      spa: true
    });
  };
  return react.createElement(List_styles_Container, {
    columns: columns,
    "data-testid": "list-variation"
  }, posts == null ? void 0 : posts.map(function (_ref2) {
    var _image$urls, _parseDateTime;
    var id = _ref2.id,
      image = _ref2.image,
      title = _ref2.title,
      categoryId = _ref2.categoryId,
      categoryTitle = _ref2.categoryTitle,
      updatedAt = _ref2.updatedAt,
      subtitle = _ref2.subtitle,
      slug = _ref2.slug,
      category = _ref2.category,
      subcategory = _ref2.subcategory;
    return react.createElement(Card/* default */.ZP, {
      key: id,
      as: "a",
      href: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(id, "/"),
      backgroundColor: cardTheme,
      enableHover: true,
      "data-testid": "list-card",
      onClick: function onClick(e) {
        return handlePostClick(categoryId, title, e, slug, id);
      },
      gridTemplateColumns: "1fr",
      gridTemplateRows: ['250px auto', '190px auto', '190px auto']
    }, react.createElement(Card/* default.Image */.ZP.Image, {
      src: "".concat(image == null ? void 0 : (_image$urls = image.urls) == null ? void 0 : _image$urls["default"], "?ims=fit-in/{w}x"),
      alt: image.alt,
      imageHeight: "250px",
      objectFit: "cover",
      srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
      width: viewport === 'mobile' ? 380 : 327
    }), react.createElement(Card/* default.Body */.ZP.Body, null, react.createElement(Card/* default.Title */.ZP.Title, {
      forwardedAs: titleAs,
      truncate: true,
      lines: 2,
      lineHeight: ['display', 'input', 'input'],
      fontSize: [3, 4, 4]
    }, title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
      fontSize: [null, 1, 1]
    }, Boolean(updatedAt) && "".concat((_parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt)) == null ? void 0 : _parseDateTime.getShortMonthYear, " | "), react.createElement(Text/* default */.Z, {
      fontWeight: "bold",
      color: "inherit",
      display: "inline-block"
    }, categoryTitle)), displaySubtitle && react.createElement(Card/* default.Text */.ZP.Text, {
      truncate: true,
      lines: 4,
      fontSize: [null, 3, 3]
    }, subtitle), subcategory && react.createElement(Link/* default */.Z, {
      p: "8px 0",
      color: "inherit",
      fontWeight: "bold",
      "data-testid": "blog-subCategory-link",
      href: createCustomUrl(category, subcategory),
      onClick: function onClick(e) {
        return handleSubCategoryPostClick(category, subcategory, e);
      }
    }, subcategory.title)));
  }));
}
 false ? 0 : void 0;
List_List.defaultProps = {
  cardTheme: 'background.light',
  columns: 4,
  customBasePath: '',
  displaySubtitle: true,
  titleAs: 'h3',
  viewport: 'mobile'
};
/* harmony default export */ var Variations_List_List = (List_List);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/List/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/VerticalList/VerticalList.js









function VerticalList(_ref) {
  var posts = _ref.posts,
    cardTheme = _ref.cardTheme,
    titleAs = _ref.titleAs,
    viewport = _ref.viewport,
    customBasePath = _ref.customBasePath;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handlePostClick = function handlePostClick(categoryId, title, e, slug, postId) {
    e.preventDefault();
    var recomendationLayout = 'VerticalList';
    (0,utils_build_esm/* routePush */.dY)({
      path: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(postId, "/"),
      spa: true
    });
    publish('blogpost:click', {
      categoryId: categoryId,
      recomendationLayout: recomendationLayout,
      title: title
    });
  };
  var handleSubCategoryPostClick = function handleSubCategoryPostClick(category, subcategory, e) {
    e.stopPropagation();
    var subcategoryUrl = createCustomUrl(category, subcategory);
    (0,utils_build_esm/* routePush */.dY)({
      path: subcategoryUrl,
      spa: true
    });
    e.stopPropagation();
  };
  return react.createElement(Flex/* default */.Z, {
    gap: 4,
    flexWrap: "wrap",
    flexDirection: "column",
    justifyContent: "space-between",
    "data-testid": "list-vertical-variation"
  }, posts == null ? void 0 : posts.map(function (_ref2) {
    var _image$urls, _parseDateTime;
    var id = _ref2.id,
      image = _ref2.image,
      title = _ref2.title,
      categoryId = _ref2.categoryId,
      categoryTitle = _ref2.categoryTitle,
      updatedAt = _ref2.updatedAt,
      slug = _ref2.slug,
      category = _ref2.category,
      subcategory = _ref2.subcategory;
    return react.createElement(Card/* default */.ZP, {
      key: id,
      as: "a",
      href: "".concat(customBasePath, "/blog-da-lu/c/").concat(slug, "/").concat(id, "/"),
      backgroundColor: cardTheme,
      enableHover: true,
      "data-testid": "list-vertical-card",
      gridTemplateAreas: ["'image' 'body'", "'image' 'body'", "'image body'"],
      gridTemplateColumns: ['1fr', '1fr', '140px 1fr'],
      gridTemplateRows: ['250px auto', '190px auto', 'unset'],
      height: ['auto', 'auto', '120px'],
      onClick: function onClick(e) {
        return handlePostClick(categoryId, title, e, slug, id);
      }
    }, react.createElement(Card/* default.Image */.ZP.Image, {
      src: "".concat(image == null ? void 0 : (_image$urls = image.urls) == null ? void 0 : _image$urls["default"], "?ims=fit-in/{w}x"),
      alt: image.alt,
      objectFit: "cover",
      borderRadius: 6,
      srcSetDensity: viewport === 'mobile' ? [1, 1.5, 2] : [],
      width: viewport === 'mobile' ? 380 : 200
    }), react.createElement(Card/* default.Body */.ZP.Body, {
      justifyContent: ['initial', 'initial', 'space-between'],
      padding: ['16px 14px', '16px 14px', 2]
    }, react.createElement(Card/* default.Title */.ZP.Title, {
      forwardedAs: titleAs,
      truncate: true,
      lines: 2,
      color: "text.base",
      fontSize: [3, 3, 2]
    }, title), react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
      color: "text.base"
    }, react.createElement(Text/* default */.Z, {
      fontWeight: "bold",
      color: "text.primary",
      display: "inline-block"
    }, categoryTitle), !!updatedAt && react.createElement(Text/* default */.Z, {
      display: "inline-block"
    }, "\xA0\xA0 \u2022 \xA0\xA0", (_parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt)) == null ? void 0 : _parseDateTime.getShortMonthYear)), subcategory && react.createElement(Link/* default */.Z, {
      p: "8px 0",
      color: "inherit",
      fontWeight: "bold",
      "data-testid": "blog-subCategory-link",
      href: createCustomUrl(category, subcategory),
      onClick: function onClick(e) {
        return handleSubCategoryPostClick(category, subcategory, e);
      }
    }, subcategory.title)));
  }));
}
 false ? 0 : void 0;
VerticalList.defaultProps = {
  cardTheme: 'background.light',
  customBasePath: '',
  titleAs: 'h3',
  viewport: 'mobile'
};
/* harmony default export */ var VerticalList_VerticalList = (VerticalList);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/VerticalList/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/variations.js






var backgroundVariations = {
  dark: 'background.primary',
  light: 'background.base'
};
var setGutter = function setGutter(gutter) {
  return gutter ? 3 : 0;
};
var variations = {
  bannerCarousel: {
    component: BannerCarousel_BannerCarousel,
    disableBackground: false,
    displaySubtitle: true,
    marginTop: [4, 4, 5],
    paddingBottom: 0,
    paddingX: setGutter(false)
  },
  carousel: {
    component: Variations_Carousel_Carousel,
    disableBackground: false,
    displaySubtitle: true,
    marginTop: [4, 4, 5],
    paddingBottom: 0,
    paddingX: setGutter(true)
  },
  highlight: {
    component: Highlight_Highlight,
    disableBackground: true,
    displaySubtitle: true,
    marginTop: [4, 4, 5],
    paddingBottom: 0,
    paddingX: setGutter(true)
  },
  list: {
    component: Variations_List_List,
    disableBackground: false,
    displaySubtitle: true,
    marginTop: [4, 4, 5],
    paddingX: setGutter(true)
  },
  verticalList: {
    component: VerticalList_VerticalList,
    disableBackground: false,
    displaySubtitle: true,
    paddingX: setGutter(false)
  }
};
var getVariation = function getVariation(variation) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$backgroundColorT = _ref.backgroundColorToken,
    backgroundColorToken = _ref$backgroundColorT === void 0 ? '' : _ref$backgroundColorT,
    _ref$cardColorTheme = _ref.cardColorTheme,
    cardColorTheme = _ref$cardColorTheme === void 0 ? '' : _ref$cardColorTheme,
    _ref$overrideVariatio = _ref.overrideVariations,
    overrideVariations = _ref$overrideVariatio === void 0 ? {} : _ref$overrideVariatio,
    viewport = _ref.viewport;
  var settings = (0,esm_extends/* default */.Z)({}, variations[variation] || variations.list, overrideVariations[variation]);
  var backgroundColor = backgroundVariations[backgroundColorToken] || backgroundVariations.dark;
  var paddingY = backgroundColorToken === 'dark' && !(settings == null ? void 0 : settings.disableBackground) ? 5 : 3;
  var cardColor = backgroundColorToken === 'light' && cardColorTheme === 'dark' || (settings == null ? void 0 : settings.disableBackground) ? "card.darkest" : "card.".concat(cardColorTheme || 'light');
  var paddingXTitle = !(settings == null ? void 0 : settings.paddingX) && viewport === 'mobile' ? setGutter(true) : 0;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: backgroundColor,
    cardColor: cardColor,
    paddingXTitle: paddingXTitle,
    paddingY: paddingY,
    setGutter: setGutter
  }, settings);
};
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/Variations/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/BlogRecommendation.js


var BlogRecommendation_excluded = ["component", "backgroundColor", "cardColor", "disableBackground", "gutter", "displaySubtitle", "title"];








function BlogRecommendation(_ref) {
  var staticProps = _ref["static"],
    _ref$structure = _ref.structure,
    blogTheme = _ref$structure.theme,
    device = _ref$structure.device;
  var _staticProps$viewport = staticProps.viewport,
    viewport = _staticProps$viewport === void 0 ? device : _staticProps$viewport,
    columns = staticProps.columns,
    _staticProps$titleAs = staticProps.titleAs,
    titleAs = _staticProps$titleAs === void 0 ? 'h2' : _staticProps$titleAs,
    _staticProps$postTitl = staticProps.postTitleAs,
    postTitleAs = _staticProps$postTitl === void 0 ? 'h3' : _staticProps$postTitl,
    _staticProps$override = staticProps.overrideVariations,
    overrideVariations = _staticProps$override === void 0 ? {} : _staticProps$override,
    seeMoreLabel = staticProps.seeMoreLabel,
    basePath = staticProps.basePath,
    _staticProps$customBa = staticProps.customBasePath,
    customBasePath = _staticProps$customBa === void 0 ? '' : _staticProps$customBa;
  var recommendations = Array.isArray(staticProps == null ? void 0 : staticProps.recommendations) ? staticProps == null ? void 0 : staticProps.recommendations : [staticProps == null ? void 0 : staticProps.recommendations].filter(Boolean);
  var handleClick = function handleClick(e, url) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: url,
      spa: true
    });
  };
  return recommendations.map(function (_ref2) {
    var blogCategoryId = _ref2.blogCategoryId,
      categoryId = _ref2.categoryId,
      parentCategoryId = _ref2.parentCategoryId,
      link = _ref2.link,
      title = _ref2.title,
      variation = _ref2.variation,
      theme = _ref2.theme,
      posts = _ref2.posts;
    var backgroundColorToken = theme.background,
      cardColorTheme = theme.card;
    var _getVariation = getVariation(variation, {
        backgroundColorToken: backgroundColorToken,
        cardColorTheme: cardColorTheme,
        overrideVariations: overrideVariations
      }),
      Recommendation = _getVariation.component,
      backgroundColor = _getVariation.backgroundColor,
      cardColor = _getVariation.cardColor,
      disableBackground = _getVariation.disableBackground,
      gutter = _getVariation.gutter,
      displaySubtitle = _getVariation.displaySubtitle,
      _getVariation$title = _getVariation.title,
      _getVariation$title2 = _getVariation$title === void 0 ? {} : _getVariation$title,
      _getVariation$title2$ = _getVariation$title2.fontWeight,
      fontWeight = _getVariation$title2$ === void 0 ? '500' : _getVariation$title2$,
      variationProps = (0,objectWithoutProperties/* default */.Z)(_getVariation, BlogRecommendation_excluded);
    var isSeeMore = Boolean(link || blogCategoryId);
    var isAbsoluteLink = Boolean(link == null ? void 0 : link.startsWith('/blog-da-lu'));
    var categoryUrl = parentCategoryId ? "".concat(basePath, "/s/").concat(parentCategoryId == null ? void 0 : parentCategoryId.toLowerCase(), "/").concat(categoryId == null ? void 0 : categoryId.toLowerCase(), "/").concat(link, "/").concat(blogCategoryId, "/") : "".concat(basePath, "/l/").concat(categoryId == null ? void 0 : categoryId.toLowerCase(), "/").concat(link, "/").concat(blogCategoryId, "/");
    var url = "".concat(customBasePath).concat(isAbsoluteLink ? link : categoryUrl);
    return Boolean(posts) && Boolean(posts.length) && react.createElement(BlogRecommendation_styles_Container, (0,esm_extends/* default */.Z)({
      key: title,
      gutter: gutter,
      disableBackground: disableBackground,
      backgroundColor: backgroundColor
    }, variationProps), react.createElement(Content, (0,esm_extends/* default */.Z)({
      backgroundTheme: disableBackground ? 'transparent' : backgroundColor
    }, blogTheme), react.createElement(TitleContainer, null, Boolean(title) && react.createElement(Title, {
      forwardedAs: titleAs,
      children: title,
      fontSize: 5,
      fontWeight: fontWeight,
      lineHeight: 1,
      mb: 4,
      color: "inherit"
    }), Boolean(isSeeMore) && react.createElement(Link/* default */.Z, {
      href: url,
      onClick: function onClick(e) {
        return handleClick(e, url);
      },
      "data-testid": "see-more-link",
      color: "inherit"
    }, react.createElement(Text/* default */.Z, {
      "data-testid": "see-more-label",
      color: "inherit",
      fontWeight: "bold",
      fontSize: 1
    }, seeMoreLabel))), react.createElement(Recommendation, {
      columns: columns,
      posts: posts,
      cardTheme: cardColor,
      viewport: viewport,
      titleAs: postTitleAs,
      displaySubtitle: displaySubtitle,
      recomendationTitle: title,
      customBasePath: customBasePath
    })));
  });
}
 false ? 0 : void 0;
BlogRecommendation.defaultProps = {
  data: {},
  "static": {
    customBasePath: '',
    recommendations: []
  },
  structure: {}
};
BlogRecommendation.ssr = true;
/* harmony default export */ var BlogRecommendation_BlogRecommendation = ((0,withLayoutProps/* default */.Z)(BlogRecommendation));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogRecommendation/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/IconButton/index.js + 2 modules
var IconButton = __webpack_require__(15309);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/BlogHeader.styles.js


var BlogHeader_styles_templateObject, BlogHeader_styles_templateObject2, BlogHeader_styles_templateObject3;




var BlogHeader_styles_Container = styled_components_browser_esm["default"].header(BlogHeader_styles_templateObject || (BlogHeader_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BlogHeader_styles_Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.primary',
    color: 'text.light'
  }, props);
})(BlogHeader_styles_templateObject2 || (BlogHeader_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  padding: ", "px ", "px;\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  align-items: center;\n"])), function (props) {
  return (0,build_esm.themeGet)('sizes.header')(props);
}, (0,build_esm.themeGet)('space.3'), (0,build_esm.themeGet)('space.4'));
var Logo = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(BlogHeader_styles_templateObject3 || (BlogHeader_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-self: center;\n"])));
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(88699);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var molecules_List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogEcommerceLink/BlogEcommerceLink.js


var BlogEcommerceLink_excluded = ["backgroundColor", "href", "label", "textColor"];







var BlogEcommerceLink = function BlogEcommerceLink(_ref) {
  var backgroundColor = _ref.backgroundColor,
    href = _ref.href,
    label = _ref.label,
    textColor = _ref.textColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, BlogEcommerceLink_excluded);
  return react.createElement(Link/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "blog-ecommerce-link",
    href: href
  }, props), react.createElement(Flex/* default */.Z, {
    "data-testid": "blog-ecommerce-link-container",
    alignItems: "center",
    justifyContent: "center",
    bg: backgroundColor,
    p: 3,
    borderRadius: "12px",
    width: 230,
    height: 48,
    columnGap: 2
  }, react.createElement(Text/* default */.Z, {
    "data-testid": "blog-ecommerce-link-label",
    color: textColor,
    fontWeight: "bold",
    fontSize: 1
  }, label), react.createElement(esm/* Icon */.JO$, {
    name: "OpenLink",
    color: textColor
  })));
};
 false ? 0 : void 0;
BlogEcommerceLink.defaultProps = {
  backgroundColor: 'primary.base',
  textColor: 'text.light'
};
/* harmony default export */ var BlogEcommerceLink_BlogEcommerceLink = ((0,withLayoutProps/* default */.Z)(BlogEcommerceLink));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogEcommerceLink/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/BlogSidebarMenu/BlogSidebarMenu.styles.js


var BlogSidebarMenu_styles_templateObject, BlogSidebarMenu_styles_templateObject2, BlogSidebarMenu_styles_templateObject3, BlogSidebarMenu_styles_templateObject4, BlogSidebarMenu_styles_templateObject5, BlogSidebarMenu_styles_templateObject6;






var BlogSidebarMenu_styles_Container = (0,styled_components_browser_esm["default"])(Grid/* default */.Z).attrs(function () {
  return {
    backgroundColor: 'background.base',
    height: '100vh'
  };
})(BlogSidebarMenu_styles_templateObject || (BlogSidebarMenu_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-template-rows: 80px 1fr 80px;\n"])));
var BlogSidebarMenu_styles_Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    mx: 3,
    my: 4
  };
})(BlogSidebarMenu_styles_templateObject2 || (BlogSidebarMenu_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BlogSidebarMenu_styles_Logo = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(BlogSidebarMenu_styles_templateObject3 || (BlogSidebarMenu_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-self: left;\n"])));
var SectionHeader = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(BlogSidebarMenu_styles_templateObject4 || (BlogSidebarMenu_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var SidebarFooter = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.light'
  }, props);
})(BlogSidebarMenu_styles_templateObject5 || (BlogSidebarMenu_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.25);\n  justify-content: center;\n"])), function (props) {
  return (0,build_esm.themeGet)('sizes.header')(props);
});
var SidebarHeader = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.primary',
    color: 'text.light'
  }, props);
})(BlogSidebarMenu_styles_templateObject6 || (BlogSidebarMenu_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: ", ";\n  padding: ", "px;\n  padding-bottom: ", "px;\n  display: grid;\n  justify-items: right;\n"])), function (props) {
  return (0,build_esm.themeGet)('sizes.header')(props);
}, (0,build_esm.themeGet)('space.2'), (0,build_esm.themeGet)('space.4'));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/BlogSidebarMenu/BlogSidebarMenu.js















var BlogSidebarMenu = function BlogSidebarMenu(_ref) {
  var ecommerceLink = _ref.ecommerceLink,
    linkGroups = _ref.linkGroups,
    onCloseMenuClick = _ref.onCloseMenuClick,
    onLogoClick = _ref.onLogoClick,
    onMenuItemClick = _ref.onMenuItemClick;
  var _useState = (0,react.useState)({}),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openGroups = _useState2[0],
    setOpenGroups = _useState2[1];
  return react.createElement(BlogSidebarMenu_styles_Container, {
    "data-testid": "blog-menu-container"
  }, react.createElement(SectionHeader, null, react.createElement(SidebarHeader, null, react.createElement(IconButton/* default */.Z, {
    name: "Close",
    onClick: onCloseMenuClick
  }, react.createElement(esm/* Close */.x8P, {
    role: "button",
    "aria-label": "fechar o menu",
    "data-testid": "btn-close-menu",
    color: "text.light",
    width: 20,
    height: 20
  })), react.createElement(BlogSidebarMenu_styles_Logo, {
    onClick: onLogoClick,
    "data-testid": "sidebar-logo",
    "aria-label": "ir para p\xE1gina inicial"
  }, react.createElement(esm/* Icon */.JO$, {
    name: "LogoBlogLu",
    color: "text.light",
    width: 150,
    height: 27
  }))), react.createElement(Strip/* default */.Z, {
    position: "relative"
  })), react.createElement(BlogSidebarMenu_styles_Content, null, Boolean(linkGroups == null ? void 0 : linkGroups.length) && react.createElement(react.Fragment, null, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    fontSize: 3
  }, "Assuntos"), react.createElement(Box/* default */.Z, {
    bg: "background.light",
    borderRadius: "big",
    marginBottom: 10,
    marginTop: 10
  }, react.createElement(molecules_List/* default */.Z, {
    divided: true
  }, linkGroups == null ? void 0 : linkGroups.map(function (_ref2, groupIndex) {
    var label = _ref2.label,
      linkList = _ref2.linkList;
    return react.createElement(react.Fragment, null, react.createElement(molecules_List/* default.Item */.Z.Item, {
      "data-testid": "blog-menu-group-item",
      key: "link-group-".concat((0,lodash.uniqueId)(label)),
      fill: "primary",
      onClick: function onClick() {
        setOpenGroups(function (currentGroups) {
          var currentState = currentGroups[groupIndex] || false;
          return (0,esm_extends/* default */.Z)({}, currentGroups, (0,defineProperty/* default */.Z)({}, groupIndex, !currentState));
        });
      },
      endIcon: openGroups[groupIndex] ? 'ChevronUp' : 'ChevronDown'
    }, label), react.createElement(Collapse/* default */.Z, {
      trigger: openGroups[groupIndex]
    }, linkList.map(function (item) {
      return react.createElement(molecules_List/* default.Item */.Z.Item, {
        "data-testid": "blog-menu-link-item",
        as: "a",
        key: "link-item-".concat((0,lodash.uniqueId)(label), "-").concat((0,lodash.uniqueId)(item.value)),
        alt: item.alt,
        inset: true,
        color: "text.primary",
        href: item.href,
        onClick: function onClick(e) {
          return onMenuItemClick(e, item);
        }
      }, item.value);
    })));
  }))))), react.createElement(SidebarFooter, null, react.createElement(BlogEcommerceLink_BlogEcommerceLink, ecommerceLink)));
};
 false ? 0 : void 0;
BlogSidebarMenu.defaultProps = {
  linkGroups: []
};
/* harmony default export */ var BlogSidebarMenu_BlogSidebarMenu = (BlogSidebarMenu);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/BlogSidebarMenu/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/BlogHeader.js











var BlogHeader = function BlogHeader(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data;
  var _data$blogHeader = data.blogHeader,
    headerData = _data$blogHeader === void 0 ? {} : _data$blogHeader;
  var linksGroups = (headerData == null ? void 0 : headerData.LinksGroup) || [];
  var ecommerceLink = staticProps.ecommerceLink,
    logo = staticProps.logo;
  var _ref2 = (headerData == null ? void 0 : headerData.linkList) || [],
    linkList = _ref2.linkList;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleMenuItemClick = function handleMenuItemClick(e, item) {
    e.preventDefault();
    setOpen(false);
    (0,utils_build_esm/* routePush */.dY)({
      path: item.href,
      spa: true
    });
  };
  var handleLogoClick = function handleLogoClick(e) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: logo.url,
      spa: true
    });
  };
  return react.createElement(BlogHeader_styles_Container, {
    "data-testid": "blog-header-container"
  }, react.createElement(BlogHeader_styles_Content, null, react.createElement(IconButton/* default */.Z, {
    name: "Burger",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, react.createElement(esm/* Burger */.OWX, {
    role: "button",
    "aria-label": "abrir o menu",
    "data-testid": "button-burger",
    color: "#fff"
  })), react.createElement(Logo, {
    onClick: handleLogoClick,
    href: logo.url,
    "data-testid": "logo",
    "aria-label": "ir para p\xE1gina inicial"
  }, react.createElement(esm/* LogoBlogLu */.dnF, {
    color: "text.light",
    width: 150,
    height: 27
  }))), react.createElement(Strip/* default */.Z, {
    position: "relative"
  }), react.createElement(Sidebar/* default */.Z, {
    visible: open,
    bg: "base",
    onClickOutside: function onClickOutside() {
      return setOpen(false);
    }
  }, react.createElement(BlogSidebarMenu_BlogSidebarMenu, {
    linkList: linkList,
    linkGroups: linksGroups,
    onCloseMenuClick: function onCloseMenuClick() {
      return setOpen(false);
    },
    onMenuItemClick: handleMenuItemClick,
    onLogoClick: handleLogoClick,
    ecommerceLink: ecommerceLink
  })));
};
 false ? 0 : void 0;
BlogHeader.defaultProps = {
  data: {},
  "static": {}
};
BlogHeader.ssr = true;
BlogHeader.displayName = 'BlogHeader';
/* harmony default export */ var BlogHeader_BlogHeader = ((0,withLayoutProps/* default */.Z)(BlogHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeader/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/BlogDropdownMenuDesk/BlogDropdownMenuDesk.styles.js

var BlogDropdownMenuDesk_styles_templateObject, BlogDropdownMenuDesk_styles_templateObject2, BlogDropdownMenuDesk_styles_templateObject3, BlogDropdownMenuDesk_styles_templateObject4, BlogDropdownMenuDesk_styles_templateObject5;





var BlogDropdownMenuDesk_styles_Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(BlogDropdownMenuDesk_styles_templateObject || (BlogDropdownMenuDesk_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
var BlogDropdownMenuDesk_styles_List = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(BlogDropdownMenuDesk_styles_templateObject2 || (BlogDropdownMenuDesk_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: row;\n  justify-content: center;\n"])));
var ListLabel = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    fontWeight: 'bold'
  };
})(BlogDropdownMenuDesk_styles_templateObject3 || (BlogDropdownMenuDesk_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 10px 16px;\n  margin-right: 10px;\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n  }\n"])), function (props) {
  return (0,build_esm.getTextColor)('primary')(props);
}, function (props) {
  return (0,build_esm.getBackgroundColor)('light')(props);
});
var SubLinks = (0,styled_components_browser_esm["default"])(Link/* default */.Z).attrs(function () {
  return {
    color: 'text.base',
    fontWeight: 'bold',
    marginRight: '20px'
  };
})(BlogDropdownMenuDesk_styles_templateObject4 || (BlogDropdownMenuDesk_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-shadow: ", ";\n  padding-bottom: 20px;\n  cursor: pointer;\n  &:hover {\n    text-decoration: none;\n    color: ", ";\n  }\n"])), function (props) {
  return (0,build_esm.themeGet)('boxShadows.5')(props);
}, function (props) {
  return (0,build_esm.getTextColor)('primary')(props);
});
var SubLinksContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    backgroundColor: 'background.light'
  };
})(BlogDropdownMenuDesk_styles_templateObject5 || (BlogDropdownMenuDesk_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  top: calc(100% - 8px);\n  left: 0;\n  width: 100%;\n  position: absolute;\n  z-index: ", ";\n  display: flex;\n  padding: 32px 100px;\n  flex-wrap: wrap;\n  gap: 30px;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n\n  &.visible {\n    visibility: visible;\n    opacity: 1;\n    pointer-events: auto;\n    transition: opacity 0.2s ease, visibility 0.2s ease;\n  }\n"])), function (props) {
  return (0,build_esm.themeGet)('zIndices.4')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/BlogDropdownMenuDesk/BlogDropdownMenuDesk.js





var BlogDropdownMenuDesk = function BlogDropdownMenuDesk(_ref) {
  var linkGroups = _ref.linkGroups,
    onMenuItemClick = _ref.onMenuItemClick;
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openGroup = _useState2[0],
    setOpenGroup = _useState2[1];
  return react.createElement(BlogDropdownMenuDesk_styles_Content, {
    "data-testid": "blog-content-group-item",
    onMouseLeave: function onMouseLeave() {
      return setOpenGroup(null);
    }
  }, !!(linkGroups == null ? void 0 : linkGroups.length) && react.createElement(BlogDropdownMenuDesk_styles_List, null, linkGroups.map(function (_ref2) {
    var label = _ref2.label,
      linkList = _ref2.linkList;
    var isOpen = openGroup === label;
    return react.createElement(ListLabel, {
      "data-testid": "blog-menu-group-item",
      key: "link-group-".concat((0,lodash.uniqueId)(label)),
      fill: "primary",
      onMouseEnter: function onMouseEnter() {
        return setOpenGroup(label);
      }
    }, label, react.createElement(SubLinksContainer, {
      "data-testid": "blog-sub-container-link-item",
      className: isOpen ? 'visible' : 'hidden'
    }, linkList.map(function (item) {
      return react.createElement(SubLinks, {
        "data-testid": "blog-sub-link-item",
        key: "link-item-".concat((0,lodash.uniqueId)(label), "-").concat((0,lodash.uniqueId)(item.value)),
        href: item.href,
        alt: item.alt,
        onClick: function onClick(e) {
          return onMenuItemClick(e, item);
        }
      }, item.value);
    })));
  })));
};
 false ? 0 : void 0;
BlogDropdownMenuDesk.defaultProps = {
  linkGroups: []
};
/* harmony default export */ var BlogDropdownMenuDesk_BlogDropdownMenuDesk = (BlogDropdownMenuDesk);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/BlogDropdownMenuDesk/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/BlogHeaderDesk.styles.js

var BlogHeaderDesk_styles_templateObject, BlogHeaderDesk_styles_templateObject2, BlogHeaderDesk_styles_templateObject3, BlogHeaderDesk_styles_templateObject4;




var BlogLinkEcommerce = (0,styled_components_browser_esm["default"])(BlogEcommerceLink_BlogEcommerceLink)(BlogHeaderDesk_styles_templateObject || (BlogHeaderDesk_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: 1px solid white;\n  border-radius: 12px;\n  overflow: hidden;\n  justify-self: right;\n"])));
var BlogHeaderDesk_styles_Container = styled_components_browser_esm["default"].div(BlogHeaderDesk_styles_templateObject2 || (BlogHeaderDesk_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var BlogHeaderDesk_styles_Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    bg: 'primary.base',
    color: 'text.light'
  };
})(BlogHeaderDesk_styles_templateObject3 || (BlogHeaderDesk_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 30px;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 80px;\n  padding-top: 35px;\n  position: relative;\n"])));
var BlogHeaderDesk_styles_Logo = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(BlogHeaderDesk_styles_templateObject4 || (BlogHeaderDesk_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-self: left;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/BlogHeaderDesk.js









var BlogHeaderDesk = function BlogHeaderDesk(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data;
  var _data$blogHeader = data.blogHeader,
    headerData = _data$blogHeader === void 0 ? {} : _data$blogHeader;
  var _ref2 = headerData || {},
    _ref2$LinksGroup = _ref2.LinksGroup,
    linksGroups = _ref2$LinksGroup === void 0 ? [] : _ref2$LinksGroup;
  var ecommerceLink = staticProps.ecommerceLink,
    logo = staticProps.logo;
  var _ref3 = (headerData == null ? void 0 : headerData.linkList) || [],
    linkList = _ref3.linkList;
  var handleMenuItemClick = function handleMenuItemClick(e, item) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: item.href,
      spa: true
    });
  };
  var handleLogoClick = function handleLogoClick(e) {
    e.preventDefault();
    (0,utils_build_esm/* routePush */.dY)({
      path: logo.url,
      spa: true
    });
  };
  return react.createElement(react.Fragment, null, react.createElement(BlogHeaderDesk_styles_Content, {
    "data-testid": "blog-header-desk-container"
  }, react.createElement(BlogHeaderDesk_styles_Container, null, react.createElement(BlogHeaderDesk_styles_Logo, {
    onClick: handleLogoClick,
    href: logo.url,
    "data-testid": "desk-logo",
    "aria-label": "ir para p\xE1gina inicial"
  }, react.createElement(esm/* LogoBlogLu */.dnF, {
    color: "text.light",
    width: 187,
    height: 50
  })), react.createElement(BlogLinkEcommerce, (0,esm_extends/* default */.Z)({
    width: 230,
    height: 40
  }, ecommerceLink))), react.createElement(BlogDropdownMenuDesk_BlogDropdownMenuDesk, {
    linkList: linkList,
    linkGroups: linksGroups,
    onMenuItemClick: handleMenuItemClick
  })), react.createElement(Strip/* default */.Z, {
    position: "relative"
  }));
};
 false ? 0 : void 0;
BlogHeaderDesk.defaultProps = {
  data: {},
  "static": {}
};
BlogHeaderDesk.ssr = true;
BlogHeaderDesk.displayName = 'BlogHeaderDesk';
/* harmony default export */ var BlogHeaderDesk_BlogHeaderDesk = ((0,withLayoutProps/* default */.Z)(BlogHeaderDesk));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogHeaderDesk/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Breadcrumb/index.js + 2 modules
var Breadcrumb = __webpack_require__(67619);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogBreadCrumb/BlogBreadCrumb.utils.js
/* harmony default export */ var BlogBreadCrumb_utils = (function (id) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var breadcrumb = [];
  var handlePageData = function handlePageData() {
    var _data$blogCategoryCon = data.blogCategoryContent,
      blogCategoryContent = _data$blogCategoryCon === void 0 ? {} : _data$blogCategoryCon,
      _data$blogPostContent = data.blogPostContent,
      blogPostContent = _data$blogPostContent === void 0 ? {} : _data$blogPostContent;
    switch (id) {
      case 'post':
        return blogPostContent;
      case 'category':
        return {
          category: blogCategoryContent
        };
      case 'subcategory':
        return {
          category: blogCategoryContent == null ? void 0 : blogCategoryContent.parentCategory,
          subcategory: blogCategoryContent
        };
      default:
        return {};
    }
  };
  var _handlePageData = handlePageData(),
    category = _handlePageData.category,
    subcategory = _handlePageData.subcategory,
    title = _handlePageData.title;
  if (category && (category == null ? void 0 : category.categoryId)) {
    var categoryBreadcrumbItem = {
      name: category.title,
      position: 0,
      url: "/blog-da-lu/l/".concat(category.categoryId.toLowerCase(), "/").concat(category.slug, "/").concat(category.id, "/")
    };
    breadcrumb.push(categoryBreadcrumbItem);
  }
  if (subcategory && (subcategory == null ? void 0 : subcategory.categoryId)) {
    var subCategoryBreadcrumbItem = {
      name: subcategory.title,
      position: 1,
      url: "/blog-da-lu/s/".concat(category.categoryId.toLowerCase(), "/").concat(subcategory.categoryId.toLowerCase(), "/").concat(subcategory.slug, "/").concat(subcategory.id, "/")
    };
    breadcrumb.push(subCategoryBreadcrumbItem);
  }
  if (id === 'post' && title) {
    var postBreadcrumbItem = {
      name: title,
      position: subcategory ? 2 : 1,
      url: 'slug'
    };
    breadcrumb.push(postBreadcrumbItem);
  }
  return breadcrumb;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogBreadCrumb/BlogBreadCrumb.js


var BlogBreadCrumb_excluded = ["logo", "basePath"];






var BlogBreadCrumb = function BlogBreadCrumb(_ref) {
  var structure = _ref.structure,
    _ref$static = _ref["static"],
    logo = _ref$static.logo,
    basePath = _ref$static.basePath,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, BlogBreadCrumb_excluded),
    data = _ref.data;
  var id = structure.id;
  var handleLogoClick = function handleLogoClick(e) {
    e.preventDefault();
    var path = (logo == null ? void 0 : logo.url) || '/';
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var handleClickItem = function handleClickItem(e, item) {
    e.preventDefault();
    var url = item.url;
    (0,utils_build_esm/* routePush */.dY)({
      path: url,
      spa: true
    });
  };
  var itens = BlogBreadCrumb_utils(id, data);
  return react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    overflowX: "auto",
    width: "100%",
    overflowY: "hidden",
    paddingLeft: "2",
    "data-testid": "breadcrumb-container"
  }, props), react.createElement(Breadcrumb/* default */.Z, {
    items: itens,
    domain: basePath,
    onClickItem: handleClickItem,
    onLogoClick: handleLogoClick,
    logo: logo,
    isTransparent: true
  }));
};
BlogBreadCrumb.ssr = true;
 false ? 0 : void 0;
BlogBreadCrumb.defaultProps = {
  data: {}
};
/* harmony default export */ var BlogBreadCrumb_BlogBreadCrumb = (BlogBreadCrumb);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogBreadCrumb/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(33665);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPostMetaData/BlogPostMetaData.styles.js

var BlogPostMetaData_styles_templateObject, BlogPostMetaData_styles_templateObject2, BlogPostMetaData_styles_templateObject3;





var BlogPostMetaData_styles_Container = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(BlogPostMetaData_styles_templateObject || (BlogPostMetaData_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 768px;\n  grid-template-areas:\n    'category-area first-divider published-date-area'\n    'reading-time-area reading-time-area reading-time-area';\n\n  ", " {\n    grid-template-areas: 'category-area first-divider published-date-area second-divider reading-time-area';\n  }\n"])), (0,build_esm.getMediaQuery)('small'));
var Divider = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function () {
  return {
    forwardedAs: 'span'
  };
})(BlogPostMetaData_styles_templateObject2 || (BlogPostMetaData_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: ", "px;\n  grid-area: ", ";\n  border-radius: ", ";\n  width: 2px;\n  height: 2px;\n  display: ", ";\n  ", " {\n    display: block;\n  }\n"])), (0,build_esm.themeGet)('space.3'), function (_ref) {
  var gridArea = _ref.gridArea;
  return gridArea;
}, (0,build_esm.themeGet)('radii.circle'), function (_ref2) {
  var gridArea = _ref2.gridArea;
  return gridArea === 'second-divider' ? 'none' : 'block';
}, (0,build_esm.getMediaQuery)('small'));
var BlogPostMetaData_styles_Text = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(BlogPostMetaData_styles_templateObject3 || (BlogPostMetaData_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px 0;\n  grid-area: ", ";\n"])), (0,build_esm.themeGet)('space.2'), function (_ref3) {
  var gridArea = _ref3.gridArea;
  return gridArea;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPostMetaData/BlogPostMetaData.js







var BlogPostMetaData = function BlogPostMetaData(_ref) {
  var data = _ref.data,
    props = (0,esm_extends/* default */.Z)({}, ((0,objectDestructuringEmpty/* default */.Z)(_ref["static"]), _ref["static"]));
  var _ref2 = (data == null ? void 0 : data.blogPostContent) || {},
    subcategory = _ref2.subcategory,
    category = _ref2.category,
    content = _ref2.content,
    updatedAt = _ref2.updatedAt;
  var rawPostContent = (0,utils_build_esm/* sanitizeHtml */.Z6)(content, {
    rawText: true
  });
  var _readingTimeEstimator = (0,utils_build_esm/* readingTimeEstimator */.ER)(rawPostContent),
    minutes = _readingTimeEstimator.minutes;
  var _parseDateTime = (0,utils_build_esm/* parseDateTime */.wG)(updatedAt),
    getShortDate = _parseDateTime.getShortDate;
  return (0,esm_typeof/* default */.Z)(data == null ? void 0 : data.blogPostContent) === 'object' && Boolean(Object.keys(data == null ? void 0 : data.blogPostContent).length) && react.createElement(BlogPostMetaData_styles_Container, props, react.createElement(BlogPostMetaData_styles_Text, {
    color: "primary.dark",
    fontWeight: "bold",
    gridArea: "category-area",
    "data-testid": "category-metadata"
  }, (subcategory == null ? void 0 : subcategory.title) || (category == null ? void 0 : category.title)), react.createElement(Divider, {
    gridArea: "first-divider",
    backgroundColor: "primary.dark"
  }), react.createElement(BlogPostMetaData_styles_Text, {
    gridArea: "published-date-area",
    "data-testid": "date-metadata"
  }, "Atualizado em", " ", getShortDate), react.createElement(Divider, {
    gridArea: "second-divider",
    backgroundColor: "primary.dark"
  }), react.createElement(BlogPostMetaData_styles_Text, {
    gridArea: "reading-time-area",
    "data-testid": "reading-time-metadata"
  }, minutes, " ", "min de leitura"));
};
BlogPostMetaData.ssr = true;
 false ? 0 : void 0;
BlogPostMetaData.defaultProps = {
  data: {},
  "static": {}
};
/* harmony default export */ var BlogPostMetaData_BlogPostMetaData = (BlogPostMetaData);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPostMetaData/index.js

// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPostsList/BlogPostsList.js







function BlogPostsList(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var title = staticProps.title,
    theme = staticProps.theme;
  var anchorRef = (0,react.useRef)(null);
  var path = (0,utils_build_esm/* getCurrentPath */.Jz)();
  var page = (path == null ? void 0 : path.split('=')[1]) || [];
  var posts = staticProps.csr ? (0,graphql_build_esm.useBlogPostsList)({
    limit: 4
  }).posts : staticProps.posts || data.blogPostsListing.posts;
  (0,react.useEffect)(function () {
    if (page > 0) {
      (0,utils_build_esm/* scrollToRef */.BC)(anchorRef);
    }
  }, [page]);
  return react.createElement(react.Fragment, null, react.createElement("span", {
    ref: anchorRef
  }), react.createElement(BlogRecommendation_BlogRecommendation, {
    "static": (0,esm_extends/* default */.Z)({
      recommendations: [{
        posts: posts,
        theme: theme,
        title: title,
        variation: 'list'
      }]
    }, staticProps),
    structure: structure
  }));
}
 false ? 0 : void 0;
BlogPostsList.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
BlogPostsList.dataSource = {
  blogPostsListing: {
    query: 'BlogPostsListQuery'
  }
};
BlogPostsList.ssr = true;
/* harmony default export */ var BlogPostsList_BlogPostsList = ((0,withLayoutProps/* default */.Z)(BlogPostsList));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPostsList/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Pagination/index.js + 3 modules
var Pagination = __webpack_require__(19620);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPagination/BlogPagination.styles.js


var BlogPagination_styles_templateObject, BlogPagination_styles_templateObject2;



var BlogPagination_styles_Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    px: 3
  }, props);
})(BlogPagination_styles_templateObject || (BlogPagination_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BlogPagination_styles_Pagination = (0,styled_components_browser_esm["default"])(Pagination/* default */.Z)(BlogPagination_styles_templateObject2 || (BlogPagination_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  > ul {\n    margin-top: 60px;\n  }\n  > ul > li > a {\n    font-weight: 600;\n    font-size: 18px;\n    width: 40.63px;\n    height: 40px;\n    border: 1px solid #808080;\n    border-radius: 8px;\n    color: #808080;\n  }\n\n  > ul > li > a[aria-current='true'] {\n    color: #fff;\n  }\n\n  > ul > li > button {\n    align-items: center;\n    justify-content: center;\n    width: 40.63px;\n    height: 40px;\n    border: 1px solid #808080;\n    border-radius: 8px;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPagination/BlogPagination.js





var BlogPagination = function BlogPagination(_ref) {
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var canonicalPath = structure.canonicalPath,
    query = structure.query;
  var _onChange = function onChange(e, page) {
    e.preventDefault();
    var path = (0,utils_build_esm/* getCurrentPath */.Jz)({
      page: page
    });
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var _ref2 = staticProps || {},
    pagination = _ref2.pagination;
  var currentPage = query.page;
  return Boolean((pagination == null ? void 0 : pagination.pages) > 1) && react.createElement(BlogPagination_styles_Content, null, react.createElement(BlogPagination_styles_Pagination, {
    count: pagination == null ? void 0 : pagination.pages,
    page: (0,utils_build_esm/* parsePageFilter */.iz)(currentPage),
    path: canonicalPath,
    onChange: function onChange(e, page) {
      return _onChange(e, page);
    }
  }));
};
 false ? 0 : void 0;
BlogPagination.defaultProps = {
  "static": {},
  structure: {}
};
BlogPagination.ssr = true;
/* harmony default export */ var BlogPagination_BlogPagination = ((0,withLayoutProps/* default */.Z)(BlogPagination));
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogPagination/index.js

// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify = __webpack_require__(76854);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogSubLinksRelated/BlogSubLinksRelated.js






var BlogSubLinksRelated = function BlogSubLinksRelated(_ref) {
  var _data$blogCategoryCon, _parentCategory$subca;
  var data = _ref.data,
    staticProps = _ref["static"];
  var sectionTitle = staticProps == null ? void 0 : staticProps.title;
  var parentCategory = (data == null ? void 0 : (_data$blogCategoryCon = data.blogCategoryContent) == null ? void 0 : _data$blogCategoryCon.parentCategory) || {};
  var buildUrlSubcategory = function buildUrlSubcategory(categoryId, title, id) {
    return "/blog-da-lu/s/".concat(parentCategory == null ? void 0 : parentCategory.categoryId, "/").concat(categoryId, "/").concat(slugify_default()(title), "/").concat(id).toLowerCase();
  };
  return Boolean(parentCategory == null ? void 0 : (_parentCategory$subca = parentCategory.subcategories) == null ? void 0 : _parentCategory$subca.length) && react.createElement(Flex/* default */.Z, {
    flexDirection: "row",
    alignItems: "center",
    "data-testid": "blog-sub-links-container",
    maxWidth: "calc(1366px + 32px)",
    pt: "36px",
    width: "1366px",
    m: "0 auto"
  }, sectionTitle && react.createElement(Text/* default */.Z, {
    color: "inherit",
    fontWeight: "medium",
    textAlign: ['center', 'center', 'left'],
    fontSize: 3,
    "data-testid": "blog-sub-links-title"
  }, sectionTitle), react.createElement(Flex/* default */.Z, {
    columnGap: 3,
    mt: "2px",
    ml: 2,
    "data-testid": "blog-sub-links-items-container"
  }, parentCategory == null ? void 0 : parentCategory.subcategories.map(function (_ref2) {
    var categoryId = _ref2.categoryId,
      title = _ref2.title,
      id = _ref2.id;
    return react.createElement(Link/* default */.Z, {
      alt: title,
      key: "link",
      href: buildUrlSubcategory(categoryId, title, id),
      target: "_blank",
      "data-testid": "blog-sub-link-item"
    }, react.createElement(Flex/* default */.Z, {
      bg: "transparent",
      justifyContent: "center",
      alignItems: "center",
      p: 0,
      "data-testid": "blog-sub-link-text"
    }, title));
  })));
};
BlogSubLinksRelated.ssr = true;
 false ? 0 : void 0;
BlogSubLinksRelated.defaultProps = {
  data: {
    blogPostContent: {}
  },
  "static": {}
};
/* harmony default export */ var BlogSubLinksRelated_BlogSubLinksRelated = (BlogSubLinksRelated);
;// CONCATENATED MODULE: ../modules/build/esm/components/blog/BlogSubLinksRelated/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/blog/index.js














/***/ })

}]);